import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  identifyMyself: [],
  victim: [],
  anotherVictim: [],
  subject: [],
  subject2: [],
  reportID: '',
  reportingID: '',
  reportStatus: [],
  answers: [],
  selectedOptions: []
};

const formStateSlice = createSlice({
  name: 'StateForms',
  initialState: {
    identifyMyself: [],
    victim: [],
    anotherVictim: [],
    subject: [],
    subject2: [],
    reportID: '',
    reportingID: '',
    reportStatus: [],
    answers: [],
    selectedOptions: []
  },
  reducers: {
    saveIdentification: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.identifyMyself = action.payload;
    },
    saveVictim: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.victim = action.payload;
    },
    saveAnotherVictim: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.anotherVictim = action.payload;
    },
    saveSubject: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.subject = action.payload;
    },
    saveSubject2: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.subject2 = action.payload;
    },
    saveReportID: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.reportID = action.payload;
    },
    saveReportingID: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.reportingID = action.payload;
    },
    saveReportStatus: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.reportStatus = action.payload;
    },
    saveAnswers: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.answers = action.payload;
    },
    saveSelectedOptions: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.selectedOptions = action.payload;
    },
    freset: () => initialState
  }
});

export const {
  saveIdentification,
  saveVictim,
  saveAnotherVictim,
  saveSubject,
  saveSubject2,
  saveReportID,
  saveReportingID,
  saveReportStatus,
  saveAnswers,
  saveSelectedOptions,
  freset
} = formStateSlice.actions;

export default formStateSlice.reducer;
